import * as yup from "yup";
import {JobPrepColumnSort} from "../jobPrep/models";
import {JobCSColumnSort, JobCSMainColumnSort} from "./models";

export const schema = yup.object({
    range_start: yup.number().required(),
    range_end: yup.number().required(),
}).required();

export const calcSpecSortOption = [
    {
        label: "project_name",
        text: "project_name",
        value: JobCSColumnSort.project_name.toString()
    },
    {
        label: "department_name",
        text: "department_name",
        value: JobCSColumnSort.department_name.toString()
    },
    {
        label: "kind_name",
        text: "kind_name",
        value: JobCSColumnSort.kind_job.toString()
    },
    {
        label: "ts_created",
        text: "ts_created",
        value: JobCSColumnSort.request_date.toString()
    },
    {
        label: "number_id",
        text: "number_id",
        value: JobCSColumnSort.number_id.toString()
    },
    {
        label: "number_job",
        text: "number_job",
        value: JobCSColumnSort.number_job.toString()
    },
    {
        label: "other_number",
        text: "other_number",
        value: JobCSColumnSort.other_number.toString()
    },
    {
        label: "status_name",
        text: "status_name",
        value: JobCSColumnSort.status.toString()
    },
    {
        label: "date_due",
        text: "date_due",
        value: JobCSColumnSort.due_date.toString()
    },
    {
        label: "date_assigned_cs",
        text: "date_assigned_cs",
        value: JobCSColumnSort.date_assign.toString()
    },
    {
        label: "pole_total",
        text: "pole_total",
        value: JobCSColumnSort.req_pole.toString()
    },
]

export const mainCalcSpecSortOption = [
    {
        label: "project_name",
        text: "project_name",
        value: JobCSMainColumnSort.project_name.toString()
    },
    {
        label: "department_name",
        text: "department_name",
        value: JobCSMainColumnSort.department_name.toString()
    },
    {
        label: "kind_name",
        text: "kind_name",
        value: JobCSMainColumnSort.kind_job.toString()
    },
    {
        label: "ts_created",
        text: "ts_created",
        value: JobCSMainColumnSort.request_date.toString()
    },
    {
        label: "number_id",
        text: "number_id",
        value: JobCSMainColumnSort.number_id.toString()
    },
    {
        label: "number_job",
        text: "number_job",
        value: JobCSMainColumnSort.number_job.toString()
    },
    {
        label: "status_name",
        text: "status_name",
        value: JobCSMainColumnSort.status.toString()
    },
    {
        label: "date_due",
        text: "date_due",
        value: JobCSMainColumnSort.due_date.toString()
    },
    {
        label: "date_assigned_cs",
        text: "date_assigned_cs",
        value: JobCSMainColumnSort.date_assign.toString()
    },
    {
        label: "pole_total",
        text: "pole_total",
        value: JobCSMainColumnSort.req_pole.toString()
    },
]